import { randomstring } from '@/utilities/utils';
import type { ITranslationKey } from '../TranslationKey';
import type { readonly } from 'vue';

export class WizardPageDefinition {
    /**
     * Unique name for the page.
     *
     * This is used to target the slot for the page content
     */
    public Name: string;

    /**
     * TranslationKey and default text for this page
     */
    public TranslationKey: string;

    /**
     * Icon for the page
     */
    public Icon?: string;

    /**
     * Function to check if the page is valid
     */
    public Valid: () => boolean;

    /**
     * Unique id for the page
     * Used to target the page in the wizard
     */
    public readonly Id: string;

    /**
     * Creates a page
     * @param name The unique name for the page. Used to target slot for page content
     * @param translationKey An array with 2 strings containing the translationKey and fallback text for this page
     * @param icon The icon for the page
     * @param valid A function to check if the page is valid
     */
    constructor(name: string, translationKey: string, icon?: string, valid?: () => boolean) {
        this.Name = name;
        this.Icon = icon;
        this.TranslationKey = translationKey;
        this.Valid = valid ?? (() => true);
        this.Id = `${randomstring('wp-', '-')}${this.Name}`;
    }
}
